import {mapState} from "vuex";
export default {
    data() {
        return {
            is_loading: false,
            single: {
                duration: 30,
                meeting_date: new Date().Format("yyyy-MM-dd"),
                meeting_time: '00:00',
                user_name: '',
                user_id: '',
                email: '',
                option_mute: '1',
                option_jbh: '1',
                option_h323: '0',
                option_enroll: '0',
                group_id:null,
                usage:'办公',
                recurrent:0,
                end_meeting_date: new Date().Format("yyyy-MM-dd"),
                repeat:2,
                size:100,
                auto_record:0,
                enroll_attendees:'',
            },
            user_ids: [],
            user_id_rule: [{required: true, message: '请输入用户id', trigger: 'blur'}],
            address_book_visible: false,
            emails: [],
            repeat_options:[{name:'每日循环',value:1},{name:'每周循环',value:2},{name:'每月循环',value:3}],
            sizes:[100,200,300,500,1000,2000],
        }
    },
    watch:{
    },
    computed: {
        ...mapState(['process', 'preset','user']),
        meeting_start() {
            return this.single.meeting_date + ' ' + this.single.meeting_time;
        },
        allRoomGroups() {
            const allow = this.user ? [...this.user.allow_room_group]: [];
            const all = this.preset.app ? this.preset.app.room_groups : [];
            if (!allow || !all) return [];
            if (this.single && !allow.includes(this.single.group_id)) {
                allow.push(this.single.group_id);
            }
            return  all.filter((t) => {
                return allow.includes(t.id)
            });
        },
        duration_options(){
            const options = [];
            for(let i=0.5;i<=this.preset.app.max_hours;i+=0.5){
                options.push({label: i+'小时', value: i*60})
            }
            return options;
        },
        isWelinkMeeting(){
            return this.roomGroupPlatform === 4;
        },
        isZoom(){
            return [0,2,3].includes(this.roomGroupPlatform);
        },
        isTencentMeeting(){
            return this.roomGroupPlatform === 1;
        },
        roomGroupPlatform(){
            let platform = 0;
            if (this.preset.app.room_groups) {
                this.preset.app.room_groups.forEach((x) => {
                    if (x.id === this.single.group_id) platform = x.platform;
                })
            }
            return platform;
        }
    },
    methods: {
        handleSubmit() {
            let vm = this;
            this.$refs['MeetingForm'].validate(valid => {
                if (valid) {
                    vm.is_loading = true;
                    vm.single.attendees = JSON.stringify(vm.emails);
                    vm.$api('Admin.Meeting.Create', vm.single, true).then(() => {
                        vm.is_loading = false;
                        this.$alert('会议已经创建，通知邮件已经发送给用户，用户可以登录后进行修改。', '成功', {
                            confirmButtonText: '确定',
                            type: 'success'
                        });
                        vm.$refs['meeting_busy'].queryBF();
                        vm.is_loading = false;
                        vm.$router.push({name: '查看会议'});
                    }).catch(() => {
                        vm.is_loading = false;
                        vm.$refs['meeting_busy'].queryBF();
                    });
                } else {
                    this.$notify({
                        title: '错误',
                        message: '请按照指示填写正确的信息',
                        type: 'error'
                    });
                    return false;
                }
            });
        },
        querySearchAsync(queryString, cb) {
            if (!queryString || queryString.length < 2) return;
            this.$api('Admin.Visitor.All.UserId', {keyword:queryString}, true).then(response => {
                this.user_ids = response.data.data.map(item => {
                    return {value: item.user_id, name: item.name, email: item.email, mobile: item.mobile};
                });
                cb(this.user_ids);
            });
        },
        querySearch(queryString, cb) {
            let data = this.user_ids;
            let results = queryString ? data.filter(this.createFilter(queryString)) : data;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (item) => {
                return (item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleSelect(item) {
            this.$set(this.single, 'user_name', item.name);
            this.$set(this.single, 'email', item.email);
            this.$set(this.single,'mobile',item.mobile);
        },
        handleFreeChange(item) {
            this.single.meeting_date = item.date;
            this.single.meeting_time = item.time;
        },
        handleAddressBook() {
            this.address_book_visible = true;
        },
        handleCancel() {
            this.address_book_visible = false;
        },
        handleSuccess(val) {
            this.address_book_visible = false;
            this.emails = val;
        },
        removeEmail(val) {
            const index = this.emails.indexOf(val);
            if (index >= 0) this.emails.splice(index, 1);
        },
        importEmails(import_text) {
            this.emails = [];
            try {
                let data = JSON.parse(import_text);
                if (Array.isArray(data)) {
                    this.emails = data;
                }
            } catch (e) {
                console.log(e);
            }
        },
        makeRandomPassword() {
            this.$set(this.single,'password', Math.round(900000 * Math.random() + 100000));
        }
    },
    mounted() {
        const allow = this.user ? this.user.allow_room_group : [];
        let default_group = null;
        if (allow && allow.length) {
            default_group = allow[0];
        }
        this.single.group_id = default_group;
        this.makeRandomPassword();
    },
    created() {
        let date = new Date();
        const min = date.getMinutes();
        const new_min = Math.floor((min + 30) / 30) * 30;
        date.setMinutes(new_min);

        this.single.meeting_date = date.Format('yyyy-MM-dd');
        this.single.meeting_time = date.Format('hh:mm');

    }
}
